"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const IsNonRepresentativePopup = ({ onClose }) => (react_1.default.createElement("div", { className: 'non-representative-popup' },
    react_1.default.createElement(Popup_1.default, { onClose: onClose },
        react_1.default.createElement(ConfirmationPopup_1.default, { title: 'You should only be registering works and claiming shares for entities that you administer.', onConfirm: onClose, confirmButtonText: 'Done' },
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Are you working with a publishing rights administrator?"),
                " ",
                react_1.default.createElement("br", null),
                "If you currently work with an administrator, and that administrator registers your musical works and collects digital audio mechanicals on your behalf, then you are probably NOT a self-administered songwriter. Your administrator will work with The MLC on your behalf. If you have further questions, we encourage you to contact your rights administrator.",
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                " Still not sure? ",
                react_1.default.createElement("b", null, "Click the Chat bubble at the bottom of your screen "),
                "to connect with our Support Teams for more help.")))));
exports.default = IsNonRepresentativePopup;
